import React, { useState } from 'react';
import { downloadTicket } from '../../actions/reissueActions';

const PassengerTicket = (props) => {
    const [loading, setLoading] = useState(false);

    const getTicketDocument = async () => {
        if (props.ticket.downloadRequest) {
            const downloadRequest = {
                ...props.ticket.downloadRequest,
                ticketNumber: props.ticket.ticketDocumentNbr
            };
            const ticketList = await downloadTicket(downloadRequest);
            const matchedTicket = (ticketList || []).find(ticket => ticket.ticket === props.ticket.ticketDocumentNbr);
            return matchedTicket ? matchedTicket.document : null;
        }

        return props.ticket.document;
    };

    const handleIndividualDownload = async () => {
        if (loading) return;

        setLoading(true);
        let ticketDocument = null;
        try {
            ticketDocument = await getTicketDocument();
        } catch (error) {
            console.log("FAIL DOWNLOAD TICKET", error);
        } finally {
            setLoading(false);
        }

        if (!ticketDocument) return;
    
        const byteCharacters = atob(ticketDocument);
        const byteArray = new Uint8Array(byteCharacters.split('').map(c => c.charCodeAt(0)));
        const blob = new Blob([byteArray], { type: 'application/pdf' });
    
        const url = URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.download = `Ticket-${props.ticket.ticketDocumentNbr}.pdf`;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        URL.revokeObjectURL(url);
    };

    return (
        <tr>
            <td>{props.ticket.travelerRefNumber}</td>
            <td>{props.ticket.ticketDocumentNbr}</td>
            <td className="pb-0 pt-2">
                {props.ticket.document || props.ticket.downloadRequest ? (
                <button className="btn btn-sm btn-outline-info" onClick={handleIndividualDownload} disabled={loading}>
                    {loading ? "Descargando..." : "Descargar ticket"}
                </button>
                ) : (
                <span className="text-muted">No disponible</span>
                )}
            </td>
        </tr>
    );
};

export default PassengerTicket;
